import { enhancedApi as api } from './codegen';

const injectedRtkApi = api.enhanceEndpoints({
    endpoints: {
        usersWidgetTechnologiesList: {
            keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
        },
        widgetTechnologiesList: {
            keepUnusedDataFor: Number.MAX_SAFE_INTEGER,
        },
    },
});

/**
 * @description Use this enhanced hooks. They don't discard data when component unmounts.
 */
export const { useUsersWidgetTechnologiesListQuery, useWidgetTechnologiesListQuery } = injectedRtkApi;
